import * as React from 'react';

import { ViewLarge, Viewport, ViewSmall } from 'bernie-view';

import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkText } from 'uitk-react-text';

export interface RoomNightlyPriceProps {
  prefix?: string;
  price: string;
  qualifier: string;
  subText?: string;
  withPrice?: boolean;
}

export const RoomNightlyPrice: React.FunctionComponent<RoomNightlyPriceProps> = ({ prefix, price, qualifier, subText }) => {
  if (!price) {
    return null;
  }

  return (
    <Viewport>
      <ViewSmall>
        <>
          {prefix && (
            <UitkText dataTestId="room-nightly-price-prefix" align="left" size={100} weight="medium" theme="secondary">
              {prefix}
            </UitkText>
          )}
          <UitkLayoutFlex alignItems="center" space="one">
            <UitkLayoutFlexItem>
              <UitkText dataTestId="room-nightly-price" size={600} weight="bold">
                {price}
              </UitkText>
            </UitkLayoutFlexItem>
            {qualifier && (
              <UitkLayoutFlexItem>
                <UitkText dataTestId="room-nightly-price-qualifier" size={100} weight="bold">
                  {qualifier}
                </UitkText>
              </UitkLayoutFlexItem>
            )}
          </UitkLayoutFlex>
          {subText && (
            <UitkText dataTestId="room-nightly-price-subText" align="left" size={100} weight="medium" theme="secondary">
              {subText}
            </UitkText>
          )}
        </>
      </ViewSmall>
      <ViewLarge>
        <UitkText dataTestId="room-nightly-price" size={300} align="right" theme="secondary" className="all-y-margin-two">
          {prefix && `${prefix} `}
          <UitkText weight="bold" inline={true}>
            {price} {qualifier}
          </UitkText>
          {prefix ? ` (${subText})` : ` ${subText}`}
        </UitkText>
      </ViewLarge>
    </Viewport>
  );
};

RoomNightlyPrice.displayName = 'RoomNightlyPrice';
